module.exports = __webpack_public_path__ + "static/food-delivery-web-app-cover-82bf80eda4ad8f014937375453e229ad.png";